import { Sun, Moon } from 'lucide-react';
import { useTheme, useThemeMode } from '../../context/ThemeContext';

const ThemeToggle = () => {
  const theme = useTheme();
  const { isDark, setMode } = useThemeMode();

  const toggleTheme = () => {
    setMode(isDark ? 'light' : 'dark');
  };

  return (
    <button
      onClick={toggleTheme}
      className="p-2.5 rounded-full transition-all duration-300 hover:scale-105"
      style={{ backgroundColor: theme.cardAlt }}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {isDark ? (
        <Sun className="w-5 h-5 text-orange-400" />
      ) : (
        <Moon className="w-5 h-5 text-primary" />
      )}
    </button>
  );
};

export default ThemeToggle;